import React, { useEffect } from "react";
import { initGA, logPageView } from "../analytics";

export default function Home() {
  useEffect(() => {
    initGA();
    logPageView();

    const handleRouteChange = () => {
      logPageView();
    };

    window.addEventListener("popstate", handleRouteChange);
    return () => {
      window.removeEventListener("popstate", handleRouteChange);
    };
  }, []);

  return (
    <div>
      <h1>PLAB DESIGN</h1>
    </div>
  );
}